'use strict';

import { view } from '@/functions';

const prefix = '/arena';

export default [
    {
        path: prefix,
        name: 'arena',
        meta: {
            title: 'Arena',
            scopes: ['access_arena'],
        },
        component: () => view('arena/index'),
    },
];
